export default __webpack_public_path__ + "static/media/bg-Hex-Gradient-Connect.085e6322.jpg";